<template>
	<ClassifyContent
		:initial-company-id="1"
		:is-child-site="false"
		:initial-productnature="productnature"
	/>
</template>

<script setup>
import { watch } from 'vue';
import ClassifyContent from '@/pages/category/CategoryContent.vue';
import { buildCategoryPath } from '#shared/categoryRoutes';

definePageMeta({
	keepalive: true,
});

const route = useRoute();
const config = useRuntimeConfig();
const categoryProductnature = useCategoryProductnature(route.params.productnature ? String(route.params.productnature) : null);
const productnature = computed(() => categoryProductnature.value);
watch(
	() => route.params.productnature,
	value => {
		categoryProductnature.value = value ? String(value) : null;
	},
	{ immediate: true }
);

const title = computed(() => '全部商品分类 - 国械在线');
const description = computed(
	() => '国械在线官方平台商品分类导航页，提供医疗器械、医用耗材等全品类类目索引，支持医院、药店及及企业客户快速定位采购需求。'
);
const keywords = computed(() => '全部商品分类,国械在线');
const pcBase = (config.public.publicPcUrl || '').replace(/\/$/, '');
const canonicalHref = computed(() => {
	const path = buildCategoryPath(1, null);
	return pcBase ? `${pcBase}${path}` : '';
});

useHead(() => ({
	title: title.value,
	meta: [
		{ name: 'description', content: description.value, tagPriority: 10 },
		{ name: 'keywords', content: keywords.value, tagPriority: 10 },
	],
	link: canonicalHref.value ? [{ rel: 'canonical', href: canonicalHref.value }] : [],
}));
</script>
